class WhatsAppCheckout {
  constructor(container) {
    this.container = container;
    this.link = container.querySelector('[ref="whatsappCheckoutLink"]');
    this.form = container.closest('product-form-component');
    this.variantDataEl = container.querySelector('[data-whatsapp-variant-data]');
    this.variants = this.variantDataEl ? JSON.parse(this.variantDataEl.textContent) : [];

    this.productTitle = container.dataset.productTitle || '';
    this.productUrl = container.dataset.productUrl || '';
    this.whatsappNumber = container.dataset.whatsappNumber || '';
    this.template = container.dataset.messageTemplate ||
      "Hi, I'd like to order:\n\n{product} - {variant}\nQty: {quantity}\nPrice: {price}\n\n{url}";

    this.boundUpdate = this.update.bind(this);
    this.observe();
    this.update();
  }

  observe() {
    if (!this.form) return;

    // The theme dispatches a real VariantUpdateEvent ('variant:update')
    // whenever the selected variant changes — more reliable than
    // watching the hidden input's value attribute.
    document.addEventListener('variant:update', (e) => {
      if (e.detail?.resource) {
        this.currentVariant = e.detail.resource;
        this.update();
      }
    });

    // quantity-selector-component dispatches a real custom event,
    // QuantitySelectorUpdateEvent, from onQuantityChange() — called by
    // both the +/- buttons (updateQuantity) and the blur-commit
    // (setQuantity). e.detail.quantity is the authoritative new value,
    // already snapped to min/max/step by the component itself.
    const quantitySelector = this.form.querySelector('quantity-selector-component');
    if (quantitySelector) {
      quantitySelector.addEventListener('quantity-selector:update', (e) => {
        this.currentQuantity = e.detail.quantity;
        this.update();
      });
    }

    this.form.addEventListener('change', this.boundUpdate);
  }

  getCurrentVariant() {
    if (this.currentVariant) {
      return this.variants.find(v => v.id === this.currentVariant.id) || this.currentVariant;
    }
    const variantInput = this.form?.querySelector('[ref="variantId"]');
    const variantId = variantInput ? Number(variantInput.value) : null;
    return this.variants.find(v => v.id === variantId) || this.variants[0];
  }

  getCurrentQuantity() {
    if (this.currentQuantity != null) return this.currentQuantity;
    const quantityInput = this.form?.querySelector('input[name="quantity"]');
    return quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
  }

  formatMoney(cents) {
    const amount = cents / 100;
    const currencyCode = this.container?.dataset.currencyCode;
    if (currencyCode) {
      // minimumFractionDigits/maximumFractionDigits forced to 0 here is an
      // IDR-specific convention (no decimals shown, despite Intl's default
      // of 2). If this store ever adds a currency that does use decimals
      // (USD, EUR, etc.), this needs to become currency-aware rather than
      // a blanket zero.
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);
    }
    return amount.toLocaleString();
  }

  update() {
    const variant = this.getCurrentVariant();
    if (!variant) return;

    const quantity = this.getCurrentQuantity();
    const lineTotal = variant.price * quantity;

    const message = this.template
      .replace('{product}', this.productTitle)
      .replace('{variant}', variant.title)
      .replace('{quantity}', String(quantity))
      .replace('{price}', this.formatMoney(lineTotal))
      .replace('{url}', this.productUrl);

    const encoded = encodeURIComponent(message);
    this.link.href = `https://wa.me/${this.whatsappNumber}?text=${encoded}`;
  }
}

document.querySelectorAll('[data-whatsapp-checkout]').forEach(el => new WhatsAppCheckout(el));

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('[data-whatsapp-checkout]').forEach(el => new WhatsAppCheckout(el));
});